export const changeLabelLocale = (data = [], locale) => data.map(item => {
    if (item?.label)
        item.label = locale(item.label);
    if (item?.data)
        changeLabelLocale(item.data, locale);
    return item;
});
export const getDateLocales = (locale) => {
    const l = {};
    const key = ["monthShort", "monthFull", "dayShort", "dayFull"];
    for (const k of key) {
        l[k] = locale(k);
    }
    return l;
};
//# sourceMappingURL=locale.js.map